import React, { useEffect, useMemo, useState } from "react";
import { Card } from "../../ui";
import { CampainsCard } from "../../campains/CampainsCard";
import "../../campains/CampainsCard.css";
import "../../campains/Campains.css";
import "./Campaigns.css";
const CAMPAIGN_FIELDS = ["deliveryCamp", "paidCamp"];
const getTypeLabel = (field, lang) => {
  const labels = {
    deliveryCamp: { ar: "حملات التوصيل", en: "Delivery Campaigns" },
    paidCamp: { ar: "الحملات المدفوعة", en: "Paid Campaigns" },
  };
  return labels[field]?.[lang] || labels[field]?.ar;
};
const normalizeCampaigns = (campaigns = []) => {
  const grouped = new Map();
  campaigns.forEach((campaign) => {
    const app = campaign.app;
    const field = campaign.field || "deliveryCamp";
    if (!CAMPAIGN_FIELDS.includes(field)) return;
    const current = grouped.get(app) || {
      _id: campaign.id || app,
      app,
      deliveryCamp: [],
      paidCamp: [],
    };
    current[field].push({
      ar: campaign.titleAr || campaign.value?.ar || "",
      en: campaign.titleEn || campaign.value?.en || "",
    });
    grouped.set(app, current);
  });
  return Array.from(grouped.values());
};
export default function Campaigns({
  lang,
  text,
  campaigns,
  role,
  onSaveCampaign,
  canAct = true,
}) {
  const [campaignGroups, setCampaignGroups] = useState(() =>
    normalizeCampaigns(campaigns),
  );
  const isAdmin = role === "admin" && canAct;
  useEffect(() => {
    setCampaignGroups(normalizeCampaigns(campaigns));
  }, [campaigns]);
  const allCards = useMemo(
    () =>
      campaignGroups.flatMap((campaign) =>
        CAMPAIGN_FIELDS.flatMap((field) =>
          (campaign[field] || []).map((value, index) => ({
            app: campaign.app,
            type: getTypeLabel(field, lang),
            value,
            field,
            index,
            _id: campaign._id,
            fullData: campaign,
          })),
        ),
      ),
    [campaignGroups, lang],
  );
  // No campaign to show and nobody who can add one here: no empty card.
  if (!isAdmin && allCards.length === 0) return null;
  return (
    <section
      className={`lud-dashboard-section lud-dashboard-campaigns ${isAdmin ? "is-admin" : "is-customer"}`}
    >
      <Card className="lud-campaigns-card">
        <div className="lud-dashboard-section-title">
          <h2>{text.campaigns}</h2>
        </div>

        <div className="campains-cards-container lud-campaigns-grid">
          {allCards.map((card) => (
            <CampainsCard
              key={`${card.app}-${card.field}-${card.index}`}
              {...card}
              onUpdate={() => null}
              isDash={true}
            />
          ))}
        </div>
      </Card>
    </section>
  );
}
